"use strict";
import {
    createElementHTML,
    validaCPF,
    validaCelular
} from "./utils";
import initFormSteps from './form.steps';
import initRequestForm from './request.form';

(() => {

    window.addEventListener('DOMContentLoaded', () => {

        document.querySelectorAll('.conteudo-site').forEach((e) => {
            e.style.display = "flex";
        });

        /** */
        const form_certificado = $("#form-certificado");

        form_certificado.validate({
            ignore: ":hidden, .wrapper-validate-ignore *",
            highlight: function (input) {
                $(input).parents('.form-group').addClass('error');
                input.focus();
            },
            unhighlight: function (input) {
                $(input).parents('.form-group').removeClass('error');
            },
            errorPlacement: function (error, element) {
                $(element).parents('.input-group').append(error);
                $(element).parents('.form-group').append(error);
            },
            submitHandler: initRequestForm
        });

        /**
         * init form steps
         */
        initFormSteps();

        if ($(".mascara-cpf").length) {
            $('.mascara-cpf').mask('000.000.000-00');
            jQuery.validator.addMethod("valida-cpf", validaCPF, "Informe um CPF válido");
        }

        if ($(".mascara-celular").length) {
            $('.mascara-celular').mask('(00) 00000-0000');
            jQuery.validator.addMethod("valida-celular", validaCelular, "Informe um número válido");
        }

        const checkScrollPage = () => {

            if (window.innerWidth <= 500)
                $.scrollify.enable();
            else
                $.scrollify.disable();
        };

        if ($.scrollify) {
            $.scrollify({
                section: ".scroll-page",
                updateHash: false,
                scrollSpeed: 800
            });

            checkScrollPage();

            window.addEventListener('resize', () => {
                checkScrollPage();
            });

            document.querySelector('.scroll').addEventListener('click', (e) => {
                e.preventDefault();
                $.scrollify.next();
            });

        }

    });

})();

/**
 * @function isMobile
 * detecta se o useragent e um dispositivo mobile
 */
function isMobile() {
    var userAgent = navigator.userAgent.toLowerCase();
    if (userAgent.search(/(android|avantgo|blackberry|bolt|boost|cricket|docomo|fone|hiptop|mini|mobi|palm|phone|pie|tablet|up\.browser|up\.link|webos|wos)/i) != -1)
        return true;
}